import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { AccordionDetails } from '@mui/material';
import { Gapper } from '../utils';
import CTAButton from '../ctaButton';
import {
  StyledAccordion,
  StyledIconButton,
  AccordionSummaryStyled,
  QuestionText,
  AnswerText,
  accordionDetailsStyles,
  Wrapper,
  HeadingText,
} from './styles';

export const Accordion = ({ isOpen, onChange, order, item, ...rest }) => {
  const handleChange = (_e, isExpanded) => {
    onChange && onChange(isExpanded);
  };
  return (
    <StyledAccordion
      $isOpen={isOpen}
      expanded={isOpen}
      onChange={handleChange}
      disableGutters
      square={false}
      {...rest}
    >
      <AccordionSummaryStyled $isOpen={isOpen}>
        <QuestionText>{`${order}) ${item.q}`}</QuestionText>
        <StyledIconButton $isOpen={isOpen}>
          {isOpen ? <RemoveIcon /> : <AddIcon sx={{ fontSize: '18px' }} />}
        </StyledIconButton>
      </AccordionSummaryStyled>
      <AccordionDetails sx={accordionDetailsStyles}>
        <AnswerText>{item.a}</AnswerText>
      </AccordionDetails>
    </StyledAccordion>
  );
};

const AccordionList = ({ questions, title, buttonText, onButtonClick }) => {
  const [expanded, setExpanded] = useState(null);

  const handleChange = (key) => (isExpanded) => {
    setExpanded(isExpanded ? key : null);
  };

  const handleButtonClick = () => {
    onButtonClick && onButtonClick();
  };

  return (
    <Wrapper gap={50}>
      {title && <HeadingText dangerouslySetInnerHTML={{ __html: title }} />}
      <Gapper gap={20}>
        {questions.map((item, idx) => {
          const key = `${item.q}-${idx}`;
          const isOpen = expanded === key;

          return (
            <Accordion
              key={key}
              isOpen={isOpen}
              onChange={handleChange(key)}
              order={idx + 1}
              item={item}
            />
          );
        })}
      </Gapper>
      {buttonText && <CTAButton text={buttonText} onClick={handleButtonClick} />}
    </Wrapper>
  );
};

export default AccordionList;
